export default class MarketplaceResponseAPIResponse {
  id?: string;
  type?: string;
  isVisible?: boolean;
}
